import api from './api';

export interface PaymentProviderData {
    id?: string;
    name: string;
    type: 'vakifbank' | 'iyzico' | 'garanti' | 'paytr' | 'paynkolay';
    isActive: boolean;
    environment: 'test' | 'production';
    config: Record<string, string>;
    installmentOptions: Array<{
        count: number;
        surchargeRate: number;
        isActive: boolean;
    }>;
    commissionRate?: number;
    createdAt?: string;
    updatedAt?: string;
}

export const paymentProviderApi = {
    async getAll(): Promise<PaymentProviderData[]> {
        const response = await api.get('/admin/payment-providers');
        return response.data.providers || [];
    },

    async getById(id: string): Promise<PaymentProviderData> {
        const response = await api.get(`/admin/payment-providers/${id}`);
        return response.data;
    },

    async create(data: Omit<PaymentProviderData, 'id' | 'isActive' | 'createdAt' | 'updatedAt'>): Promise<{ id: string }> {
        const response = await api.post('/admin/payment-providers', data);
        return response.data;
    },

    async update(id: string, data: Partial<PaymentProviderData>): Promise<void> {
        await api.put(`/admin/payment-providers/${id}`, data);
    },

    async activate(id: string): Promise<void> {
        await api.put(`/admin/payment-providers/${id}/activate`);
    },

    async deactivate(id: string): Promise<void> {
        await api.put(`/admin/payment-providers/${id}/deactivate`);
    },

    async remove(id: string): Promise<void> {
        await api.delete(`/admin/payment-providers/${id}`);
    },
};
